import { graphql } from "react-relay";

// components
import "@components/autopilot-flexibility/AutopilotFlexibility.gql";
import "./organizer-autopilot-paused-freemium-callout/OrganizerAutopilotPausedFreemiumCallout.gql";

export const autopilotFormFragments = {
  org: graphql`
    fragment AutopilotForm_org on Org {
      ...AutopilotFlexibility_org
      ...OrganizerAutopilotPausedFreemiumCallout_org
      id
      experiments
      nextDefragTime {
        ... on DefragTime {
          millis
        }
      }
      suggestedInvites(first: 1000000) {
        edges {
          node {
            targetCalendarId
          }
        }
      }
      pendingInvites(first: 1000000) {
        edges {
          node {
            targetCalendarId
          }
        }
      }
      orgAccountingPeriod {
        __typename
        ... on OrgAccountingPeriod {
          periodRange {
            minDate
            maxDate
          }
          quotaMax
          quotaUsed
          enforcementState
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
    }
  `,
  event: graphql`
    fragment AutopilotForm_event on Event @argumentDefinitions(calendarId: { type: "String!" }) {
      ...AutopilotFlexibility_event
      ...OrganizerAutopilotPausedFreemiumCallout_event
      eventParentRelayId
      eventKey {
        id
        externalEventId
      }
      autopilotEventStatus(calendarId: $calendarId) {
        __typename
        ... on AutopilotEventStatus {
          status
        }
      }
      annotatedEvent {
        orgTags {
          tag
          state {
            active
            value
            subjectType
            subjectValue
            lastModified
          }
        }
      }
      annotatedRecurringEvent {
        orgTags {
          tag
          state {
            active
            value
            subjectType
            subjectValue
            lastModified
          }
        }
      }
      suggestedAutopilotSettingsResponseV3 {
        __typename
        ... on SuggestedAutopilotSettingsResponseV3 {
          intersectionOfAttendeesMeetingHours {
            minSlot {
              dayOffset
              timeSlot
            }
            maxSlot {
              dayOffset
              timeSlot
            }
          }
          calendarIdToMeetingHours {
            calendarId
            dayOffsetTimeSlotRanges {
              minSlot {
                dayOffset
                timeSlot
              }
              maxSlot {
                dayOffset
                timeSlot
              }
            }
          }
          suggestedAutopilotSettings {
            isRoomFlexible
            movementType
            allowedEndTime {
              dayOffset
              timeSlot
            }
            allowedStartTime {
              dayOffset
              timeSlot
            }
          }
        }
        ... on GraphEntityError {
          message
        }
      }
      moveRangeInLocalTimeV3 {
        __typename
        ... on MoveRangeInLocalTimeV3 {
          allowedStartTimeInclusive {
            dayOffset
            timeSlot
          }
          allowedEndTimeInclusive {
            dayOffset
            timeSlot
          }
        }
        ... on GraphEntityError {
          message
        }
      }

      featureStatesForOrganizer {
        __typename
        ... on FeatureStates {
          mixedFreemiumOrgUIState {
            autopilotPaused
            moveRangesEnabled
          }
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
    }
  `,
};
